import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import RouteBadge from './RouteBadge';

function formatTime(duration) {
  return duration.substring(0, duration.lastIndexOf(':'));
}

class TourHotelRouteItem extends React.Component {
  constructor(props) {
    super(props);
    this.setCurrentRoute = this.setCurrentRoute.bind(this);
  }
  setCurrentRoute(e) {
    e.preventDefault();
    this.props.selectRoute(this.props.route.id);
  }
  render() {
    const classes = classnames('item', { active: this.props.selected });
    const { route } = this.props;
    return (
      <div className={classes} onClick={this.setCurrentRoute} role="presentation">
        <div className="event-date">
          <div onClick={this.setCurrentRoute}>
            <strong className="event-location">
              {route.place.city}, {route.place.state}
            </strong>
            <RouteBadge related_group_events={route.related_group_events} />
            <br />

            <i className="fa fa-road fa-lg" />
            <i className="fa fa-clock-o fa-lg" title="Drive time to next venue." />
            <strong className="event-location"> {formatTime(route.duration_to_next)}</strong>
          </div>
          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

TourHotelRouteItem.propTypes = {
  route: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  selectRoute: PropTypes.func.isRequired,
};

export default TourHotelRouteItem;



// WEBPACK FOOTER //
// src/routes/tours/components/TourHotelRouteItem.js